import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const ArrowRightLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
ArrowRightLine.iconName = 'arrow-right';
ArrowRightLine.displayName = 'ArrowRightLine';
export default ArrowRightLine;
